import { CircularProgress } from '@mui/material';
import { useEffect } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { CatalogClient } from 'src/app/api/clients/catalogs';

const CatalogCheckoutComplete = () => {
  const navigate = useNavigate();
  const { merchantId, catalogId } = useParams();
  const [params] = useSearchParams();

  useEffect(() => {
    const sessionId = params.get('session_id');
    if (!sessionId || !merchantId || !catalogId) {
      alert('There was an error completing checkout. Please try again.');
      navigate('./..');
      return;
    }

    CatalogClient.verifyCatalogCheckout(merchantId, catalogId, sessionId).then(
      (data) =>
        data.data.redirect_url && window.location.assign(data.data.redirect_url)
    );
  }, []);

  return <CircularProgress />;
};

export default CatalogCheckoutComplete;
